<template>
  <div class="org-infor" v-loading="infoLoading">
    <div class="org-logo">
      <el-avatar :size="91.6" :src="orgDetailData.logoUrl" />
    </div>
    <h3 class="name-cn">{{ orgDetailData.nameCn || orgDetailData.nameEn }}</h3>
    <p class="org-location">
      {{ orgDetailData.country }}
      <span v-if="orgDetailData.city">|</span>
      {{ orgDetailData.city }}
      <span v-if="orgDetailData.district">|</span>
      {{ orgDetailData.district }}
    </p>
    <p class="innovation-index" v-if="orgType === 'company'">
      企业创新指数
      <el-tooltip class="item" effect="light" popper-class="definition-class" :content="definitionItem" placement="top">
        <img
          style="width: 14px;height: 14px"
          :src="require('@/assets/images/org/icon-question.png')"
          @mouseenter="handleGetDefinition('企业创新指数')"
          alt=""
        >
      </el-tooltip>&nbsp;
      <span>{{ orgDetailData.innovationIndex || 0}}</span>
    </p>
    <p class="innovation-index" v-else>
      科研创新指数
<!--      <el-tooltip class="item" effect="light" popper-class="definition-class" :content="definitionItem" placement="top">-->
<!--        <img-->
<!--          style="width: 14px;height: 14px"-->
<!--          :src="require('@/assets/images/org/icon-question.png')"-->
<!--          @mouseenter="handleGetDefinition('科研创新指数')"-->
<!--          alt=""-->
<!--        >-->
<!--      </el-tooltip>&nbsp;-->
      <span>{{ orgDetailData.innovationIndex || 0}}</span>
    </p>
    <div class="tag-view flex flex-wrap" v-if="orgType === 'company'">
      <span v-for="(title, idx) in orgDetailData.tag" :key="idx">{{ title }}</span>
    </div>
    <div class="filed-list" :title="orgDetailData.fieldListStr">
      <span>主要技术领域：</span>
      {{ orgDetailData.fieldListStr || '-' }}
    </div>
    <div class="interest-list">
      <span>主要研究方向：</span>
      {{ orgDetailData.interestListStr || '-' }}
    </div>

    <div class="desc">
      <span>简介：</span>
      {{ orgDetailData.description || '-' }}
    </div>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: "orgInfor",
  props: ['infoLoading', 'orgDetailData', 'orgType'],
  data() {
    return {
      definitionItem: '',
      definition: [],
    }
  },
  created() {
    // 从store中获取 保存的名词解释
    this.definition = store.state.definition;
  },
  methods: {
    // 获取名词解释
    handleGetDefinition(defin) {
      this.definitionItem = '';
      this.definition.map(item => {
        if (item.noun === defin) {
          this.definitionItem = item.definition;
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.org-infor {
  background-color: #FFFFFF;
  width: 350px;
  border-radius: 6px;
  padding: 28px 20px;
  box-sizing: border-box;
  min-height: 400px;

  .org-logo {
    display: flex;
    justify-content: center;
  }

  .name-cn {
    font-size: 18px;
    color: #101828;
    font-weight: bold;
    margin-top: 13px;
    max-width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .org-location {
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #667085;
    font-size: 16px;
    span {
      padding: 0 5px;
    }
  }

  .innovation-index {
    font-size: 16px;
    color: #333;
    margin-top: 12px;

    span {
      font-size: 16px;
      font-weight: bold;
      color: #C3A062;
    }
  }
  .tag-view{
    color: #FE8B00;
    margin-top: 8px;
    span {
      margin-bottom: 3px;
      color: #FE8B00;
      font-size: 12px;
      font-weight: 400;
      padding: 2px 5px;
      border-radius: 3px;
      background: #FFEFE5;
      margin-left: 10px;
    }
  }

  .filed-list {
    text-align: left;
    color: #333333;
    margin-top: 21px;
    line-height: 24px;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    cursor: default;
    font-size: 14px;

    span {
      color: #828A9C;
      font-size: 14px;
    }
  }

  .interest-list {
    text-align: left;
    color: #2E1F88;
    line-height: 24px;
    margin-top: 12px;

    span {
      font-size: 14px;
      color: #828A9C;
    }
  }

  .desc {
    margin-top: 19px;
    line-height: 24px;
    text-align: left;
    color: #333333;
    font-size: 14px;
    span {
      color: #828A9C;
      font-size: 14px;
    }
  }
}
</style>
